import {Injectable} from '@angular/core';
import {forkJoin} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ScriptLoaderService {
    private loadedScripts = new Set<string>();

    public loadScript(url: string): Promise<void> {
        return new Promise((resolve, reject) => {
            if (this.loadedScripts.has(url) && document.querySelector(`script[src="${url}"]`)) {
                resolve();
                return;
            }
            const script = document.createElement('script');
            script.src = url;
            script.type = 'text/javascript';
            script.onload = () => {
                this.loadedScripts.add(url);
                resolve();
            };
            script.onerror = () => reject();
            document.head.appendChild(script);
        });
    }

    public loadMultipleScripts(urls: string[] = []) {
        return forkJoin(urls.map(url => this.loadScript(url)))
    }
}
